import { FC, ReactElement } from 'react';
import { checkedCircleIcon, removeCircleIcon, warningCircleIcon } from '../../../assets/svg-icons';
import './styles.scss';

interface IMessage {
  type: string;
  text?: string;
  children?: any;
  link?: ReactElement;
  className?: string;
}

const Message: FC<IMessage> = ({ type, text, children, link, className }) => {
  return (
    <div className={`message-block ${type} ${className || ''}`}>
      <span className="icon">
        {type === 'error' ? removeCircleIcon : type === 'success' ? checkedCircleIcon : warningCircleIcon}
      </span>
      {children ? (
        children
      ) : (
        <span className="text">
          {text}
          {link}
        </span>
      )}
    </div>
  );
};

export default Message;
